import React, { createRef, useEffect, useState } from "react";
import { Row, Col, Button } from "antd";
import "./NightPlacementList.css";
import { setCaption } from "../../../../common/redux/actions/interfaceActions";
import { useDispatch, useSelector } from "react-redux";
import NightPlacementTable from "../../components/NightPlacementList/NightPlacementTable";
import {} from "../../redux/actions/personListAction";
import Sidebar from "../../components/NightPlacementList/Sidebar";
import { getOrderById } from "../../../Executorship/Order/redux/actions/orderCard";
import AddPlacementForm from "../../components/NightPlacementList/AddPlacementForm";
import {
  addPlacementToList,
  deletePlacement,
  editPlacement,
  getNightPlacementList
} from "../../redux/actions/nightPlacementListAction";

const NightPlacementList = ({ match, history }) => {
  const formRef = createRef();
  const dispatch = useDispatch();
  const orderId = match.params.id;
  const order = useSelector(state => state.Executorship.Orders.orderCard.data);
  const placementsData = useSelector(
    state => state.Lists.nightPlacement.placements
  );
  const updated = useSelector(state => state.Lists.nightPlacement.updated);
  const buttonLoading = useSelector(
    state => state.Lists.nightPlacement.buttonLoading
  );
  const tableLoading = useSelector(
    state => state.Lists.nightPlacement.tableLoading
  );

  const [formShown, toggleFormShown] = useState(false);
  const [editingPlacementInfo, toggleEditingPlacementInfo] = useState(false);
  const [placementId, setPlacementId] = useState(null);

  const driver = order && order.driver;
  const driverId = order && order.driverId;
  const responsible = order && order.responsible;
  const responsibleId =
    order && order.responsible && order.responsible.profileId;
  const vehicleId = order && order.vehicleId;
  const vehicle = order && order.vehicle;
  const orderStatusName = order && order.orderStatusName;
  const arrivalDatetime = order && order.arrivalDatetime;

  useEffect(() => {
    initCaption();
  }, [order]);

  useEffect(() => {
    dispatch(getOrderById(orderId));
    dispatch(getNightPlacementList(orderId, null, null));
  }, [orderId]);

  useEffect(() => {
    if (placementId) {
      const currentPlacementInfo = placementsData.data.find(
        placement => placement.kids_night_list_id === placementId && placement
      );
      const { place, address, organization } = currentPlacementInfo;
      if (formRef && editingPlacementInfo) {
        formRef.current.form.setFieldsValue({
          place,
          address,
          organization
        });
      }
    }
  }, [editingPlacementInfo, placementId]);

  useEffect(() => {
    setPlacementId(null);
  }, [updated]);

  const handleAddPlacementFormSubmit = values => {
    if (editingPlacementInfo) {
      dispatch(editPlacement({ ...values, orderId, placementId }));
    } else {
      dispatch(addPlacementToList({ ...values, orderId }));
    }
  };

  const initCaption = () => {
    const orderNumber =
      order &&
      order.number &&
      order.number.replace(/(\d{1,3}(?=(?:\d\d\d)+(?!\d)))/g, `$1 `);

    dispatch(
      setCaption({
        enabled: true,
        mainCaption: "Список мест размещещения детей в ночное время",
        breadCrumbs: [
          {
            path: "/control-panel",
            breadcrumbName: "Панель управления"
          },
          { path: "/executorship/order", breadcrumbName: "Исполнительство" },
          {
            path: "/executorship/order/" + orderId,
            breadcrumbName: "Заказ - " + orderNumber
          }
        ]
      })
    );
  };

  const innerHandleSubmit = () => {
    const values = formRef.current.form.getFieldsValue();
    let filledValues = {};

    for (const key in values) {
      if (values[key] !== undefined) {
        filledValues[key] = values[key];
      }
    }

    handleAddPlacementFormSubmit({ ...filledValues });
  };

  const deletePlacementFromList = placementId => {
    dispatch(deletePlacement({ orderId, placementId }));
  };

  const initEditPlacement = placementId => {
    console.log(placementId);
    toggleFormShown(true);
    toggleEditingPlacementInfo(true);
    setPlacementId(placementId);
  };

  const changeTable = (pagination, _, sorter) => {
    dispatch(getNightPlacementList(orderId, pagination, sorter));
  };

  const changePageSize = pages => {
    const pagination = {
      pageSize: pages && parseInt(pages),
      total: placementsData.total,
      current: placementsData.current_page
    };
    dispatch(getNightPlacementList(orderId, pagination, null));
  };

  const handleCancelButton = () => {
    if (editingPlacementInfo) {
      toggleFormShown(false);
      toggleEditingPlacementInfo(false);
      formRef.current.form.resetFields();
    } else {
      toggleFormShown(false);
      formRef.current.form.resetFields();
    }
  };

  return (
    <div className={"site-wrapper"}>
      <Row gutter={16} className={"placement-cols"}>
        <Col span={18}>
          {formShown && (
            <div className={"placement-form-space"}>
              <AddPlacementForm
                wrappedComponentRef={formRef}
                editingPlacementInfo={editingPlacementInfo}
              />
              <div className={"placement-button-wrapper"}>
                <Button
                  type="danger"
                  ghost
                  htmlType={"button"}
                  style={{
                    width: 176,
                    marginRight: 16
                  }}
                  onClick={handleCancelButton}
                >
                  Отмена
                </Button>
                {!editingPlacementInfo && (
                  <Button
                    type="primary"
                    htmlType={"submit"}
                    ghost
                    form="add-placement-form"
                    onClick={() => {
                      innerHandleSubmit();
                      formRef.current.form.resetFields();
                    }}
                    style={{
                      width: 176,
                      marginRight: 16
                    }}
                    loading={buttonLoading}
                  >
                    Еще место
                  </Button>
                )}
                <Button
                  type="primary"
                  htmlType={"submit"}
                  form="add-placement-form"
                  style={{
                    width: 176
                  }}
                  loading={buttonLoading}
                  onClick={() => {
                    innerHandleSubmit();
                    toggleFormShown(false);
                    formRef.current.form.resetFields();
                  }}
                >
                  Сохранить
                </Button>
              </div>
            </div>
          )}
          <NightPlacementTable
            data={placementsData}
            onChange={changeTable}
            changePageSize={changePageSize}
            loading={tableLoading}
            deletePlacementFromList={deletePlacementFromList}
            editPlacement={initEditPlacement}
          />
        </Col>
        <Col span={6}>
          <Sidebar
            toggleFormShown={toggleFormShown}
            formShown={formShown}
            currentPlacementCount={placementsData.total}
            driver={{ driver, driverId }}
            vehicle={{ vehicleId, vehicle }}
            responsible={{ ...responsible, responsibleId }}
            orderStatusName={orderStatusName}
            arrivalDatetime={arrivalDatetime}
            goBack={() => {
              history.goBack();
            }}
          />
        </Col>
      </Row>
    </div>
  );
};

export default NightPlacementList;
